<template functional>
  <div>
    <template v-if="props.row.vti_status">
      <div>VTI {{ props.row.vti_status === 'pending' ? 'zurückgenommen' : 'abgeholt' }}</div>
      <div v-if="props.row.vti_status === 'completed'">
        am {{ props.row.vti_finished_at | date }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MiaDatatableCarVtiStatusColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  methods: {
    getStatusLabel({ row, column }) {
      const status = column.meta.statusOptions().find(({ id }) => parseInt(id, 10) === parseInt(row[column.field], 10))

      return status ? status.title : ''
    },

    getStatusColor({ row, column }) {
      const status = column.meta.statusOptions().find(({ id }) => parseInt(id, 10) === parseInt(row[column.field], 10))

      return status ? status.color : '000'
    }
  }
}
</script>
